import { render, staticRenderFns } from "./DefaultDetail.vue?vue&type=template&id=3bdbb75c&"
import script from "./DefaultDetail.vue?vue&type=script&lang=js&"
export * from "./DefaultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports